
import { Component, Prop, Vue } from 'vue-property-decorator'

import { AudioRecorder } from '@/lib/chat/services/AudioRecorder'
import { ChatService } from '@/lib/chat/ChatService'
import { ChatAttachment } from '../../lib/chat/ChatAttachment'
import { FileUtils } from '@/lib/utils/FileUtils'
import { ChatMessage } from '@/lib/chat/ChatMessage'
import UIkit from 'uikit'

@Component({})
export default class ChatInputAudioComponent extends Vue {
  @Prop({ default: null }) chatService!: ChatService | null;

  audioRecorder = new AudioRecorder()
  recording = false
  duration = 0

  preventContextMenu (e: Event) {
    e.preventDefault()
  }

  record () {
    this.recording = true
    this.duration = Date.now()
    this.audioRecorder.record()
  }

  async stop () {
    this.recording = false
    const file = await this.audioRecorder.stop()
    if (!file) {
      UIkit.notification({
        message: 'Die Sprachnachricht ist zu kurz und wurde nicht hochgeladen!',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
      return
    }
    const duration = Date.now() - this.duration

    if (duration < 1000) {
      // message is shorter then 1 second, maybe clicked on accident, abort
      UIkit.notification({
        message: 'Die Sprachnachricht ist zu kurz und wurde nicht hochgeladen!',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
      return
    }
    this.send(file)
  }

  async send (file: File) {
    const message = this.$store.state.Chat.sendMessage
    message.content = ''
    message.user = this.$store.state.LoggedInUser.user
    const attachment = new ChatAttachment()
    attachment.type = ChatAttachment.ATTACHMENT_TYPE_AUDIO

    // disabled, upload whole attachment in one
    /* const attachmentBase64 = await FileUtils.toBase64(file)
    if (typeof attachmentBase64 === 'string') {
      attachment.source = attachmentBase64
    } */

    attachment.rawFile = file
    message.attachments = ([attachment])
    if (!this.chatService) {
      return
    }

    this.chatService.addMessageToQueue(message)
    this.$store.state.Chat.sendMessage = new ChatMessage()
  }
}
